import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

export type JobsDateFilterField =
  | "insertedAtStarts"
  | "insertedAtEnds"
  | "startedAtStarts"
  | "startedAtEnds"
  | "runAtStarts"
  | "runAtEnds"
  | "finishedAtStarts"
  | "finishedAtEnds";

type AdminJobsReducerType = {
  kind: Nullable<string>;
  queue: Nullable<string>;
  status: Nullable<WorkerJobStatus>;
} & Record<JobsDateFilterField, Nullable<Date>>;

const initialState: AdminJobsReducerType = {
  kind: null,
  queue: null,
  status: null,
  insertedAtStarts: null,
  insertedAtEnds: null,
  startedAtStarts: null,
  startedAtEnds: null,
  runAtStarts: null,
  runAtEnds: null,
  finishedAtStarts: null,
  finishedAtEnds: null,
};

const adminJobsSlice = createSlice({
  name: "admin/jobs",
  initialState,
  reducers: {
    setKind(state, { payload }: PayloadAction<Nullable<string>>) {
      state.kind = payload;
    },
    setQueue(state, { payload }: PayloadAction<Nullable<string>>) {
      state.queue = payload;
    },
    setStatus(state, { payload }: PayloadAction<Nullable<WorkerJobStatus>>) {
      state.status = payload;
    },
    setDateRange(state, { payload }: PayloadAction<{ field: JobsDateFilterField; value: Nullable<Date> }>) {
      state[payload.field] = payload.value;
    },

    resetFilters: () => initialState,
  },
});

export const { setKind, setQueue, setStatus, setDateRange, resetFilters } = adminJobsSlice.actions;
export const adminJobsSelector = (state: RootState) => state.admin.jobs;
export default adminJobsSlice.reducer;
